import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'النص البديل لهذه الصورة مفقود',
    noAnswers: 'لايوجد خيار للجواب، من فضلك اضغط التالي للمتابعة',
    placeholder: 'حدد من فضلك',
    pleaseSelect: 'اختر من فضلك',
    rotateLandscape: 'يرجى إيقاف قفل الاتجاه على هاتفك وتدويره إلى الوضع الأفقي للمتابعة.',
    rotatePortrait: 'يرجى إدارة الهاتف من الوضع الأفقي إلى الرأسي للمتابعة.',
    ir: {
      selectWebCam: 'اختر كاميرا الويب (إذا كانت متوفرة) أو اضغط (تصفح) لتحمل من جهازك',
      noWebCam: 'لم يتم الكشف عن كاميرا الويب',
      accessCamUpload: 'إمكانية الوصول إلى الكاميرا/ تحميل',
      browse: 'تصفح',
      uploadPhoto: 'حمل صورة',
      camera: 'كاميرا ويب',
      instead: 'عوضًا عن',
      capture: 'التقاط',
      somethingWrong: 'المعذرة، حدث خطأ ما. من فضلك حاول مرة ثانية لاحقًا',
      couldntRead: 'المعذرة، لم نستطع قراءة الرمز!',
      couldntProcess: 'المعذرة، لم نستطع معالجة صورتك!',
      inValidCode: 'Please, submit the valid code', // !
      moveOn: 'من فضلك حاول مرة ثانية أو أرسل صورتك وتابع',
      tryAgain: 'من فضلك حاول مرة أخرى',
      dataReceived: 'تم استلام البيانات!',
      enterManually: 'من فضلك حاول مرة أخرى أو أدخل البيانات يدويًا أدناه',
      positionQR: 'من فضلك ضع رمز الوصول السريع أمام كاميرتك لتلائمه ضمن الأطار الأحمر أو حمله من حاسوبك.',
      positionQRMobile: 'يُرجى وضع رمز الاستجابة السريعة أمام الكاميرا أو تحميله من جهازك.',
      analyzing: 'تحليل الصورة، انتظر من فضلك',
      submit: 'ارسال',
      startOver: 'ابدأ من جديد',
      allDone: 'أُنجز كل شيئ!',
      cantAnalyze:
        'انتباه - لم نتمكن من تقديم هذه الصورة. الرجاء محاولة إعادة التقديم أو اختيار تنسيق صورة أكثر عمومية (JPG, PNG, GIF, BMP)',
      wrongFormat: 'معذرةً - لا ندعم تنسيق الملف هذا. يُرجى تحميل نوع صورة مدعوم (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'لم يتم الكشف عن كاميرا الويب',
      uploadVideo: 'رفع مقطع فيديو',
      skip: 'تخطي؟',
      accessCamUpload: 'إمكانية الوصول إلى الكاميرا/ تحميل',
      browse: 'تصفح',
      instead: 'عوضًا عن',
      or: 'أو',
      stopRecording: 'أوقف التسجيل',
      willBeStopped: 'سيتوقف التسجيل بعد خمس دقائق',
      stopOnDone: 'أوقف التسجيل عندما تنتهي!',
      record: 'تسجيل',
      somethingWrong: 'المعذرة، حدث خطأ ما. من فضلك حاول مرة ثانية لاحقًا',
      dataReceived: 'تم استلام البيانات!',
      microphone: 'ميكروفون',
      camera: 'كاميرا ويب',
      selectMicrophone: 'حدد الميكروفون الخاص بك',
      selectCam: 'حدد كاميرا الويب الخاصة بك',
      submit: 'ارسال',
      upload: 'رفع',
      playback: 'إعادة التشغيل',
      stopPlayback: 'إيقاف استرجاع التشغيل',
      startOver: 'ابدأ من جديد',
      allDone: 'أُنجز كل شيئ!',
      alternativeRecordSpan: '',
      alrenativeRecordHref: 'من فضلك، حمل مقطع فيديو من حاسوبك.بدلًا من ذلك، تستطيع أن تسجيل فيديو عبر كاميرا الويب.',
      cantAnalyze:
        'انتباه - لم نتمكن من تقديم هذا الفيديو. يُرجى محاولة إعادة الإرسال أو اختيار تنسيق فيديو أكثر عمومية (MP4, M4V, WEBPM)',
      wrongFormat:
        'معذرةً - لا ندعم تنسيق الملف هذا. يُرجى تحميل نوع فيديو مدعوم (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'اختر',
      pleaseChoose: 'اختر من فضلك',
      this: 'هذا',
      one: 'واحد',
      myChoice: 'خياري'
    },
    hm: {
      addComment: 'من فضلك أضف تعليقًا أدناه',
      commentMandatoryPlaceHolder: 'من فضلك أضف تعليقًا الزاميًا',
      commentOptionalPlaceHolder: 'من فضلك أضف تعليقًا خياريًا',
      dragPin: 'اسحب لإعادة التموضع (النقر الطويل / الضغط للتثبيت الدقيق).',
      removePin: 'اسحب خارج الصورة للحذف',
      editComment: 'انقر/ اضغط دبوس لتعديل التعليق.',
      addPin: 'من فضلك اسحب الدبوس من اللوحة أدناه وأسقطه في المكان الذي تختاره على الصورة.',
      addPins: 'من فضلك اسحب الدبابيس من اللوحة أدناه وأسقطهم في المكان الذي تختاره على الصورة.',
      leavePins: (minPoints, maxPoints) =>
        `من فضلك اترك على الأقل ${minPoints} لكن ليس أكثر من ${maxPoints} دبوس من كل نوع.`,
      leavePinsAny: (minPoints, maxPoints) => `الرجاء ترك ${minPoints} ولكن ليس أكثر من ${maxPoints} دبابيس من أي نوع.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `من فضلك اترك على الأقل ${minPoints} لكن ليس أكثر من ${maxPoints} دبوس.`,
      leavePinsWithOff: maxPoints => `من فضلك لا تترك أكثر من ${maxPoints} دبوس من كل نوع أو انقر على التالي للتخطي.`,
      leavePinsWithOffAny: maxPoints =>
        `من فضلك لا تترك أكثر من ${maxPoints} دبابيس من أي نوع أو انقر فوق "التالي" للتخطي.`,
      leavePinsPerPageWithOff: maxPoints => `من فضلك لا تترك أكثر من ${maxPoints} دبوس أو انقر على التالي للتخطي.`,
      leavePinWithOff: `من فضلك لا تترك أكثر من دبوس واحد من كل نوع أو انقر على التالي للتخطي.`,
      leavePinWithOffAny: `الرجاء عدم ترك أكثر من دبوس واحد من أي نوع أو النقر فوق "التالي" للتخطي. `,
      leavePinPerPageWithOff: 'من فضلك لا تترك أكثر من 1 دبوس أو انقر على التالي للتخطي.',
      leaveExactlyPin: `من فضلك اترك دبوس واحد من كل نوع.`,
      leaveExactlyPinAny: `الرجاء ترك دبوس واحد من أي نوع.`,
      leaveExactlyPinPerPage: 'من فضلك اترك دبوس واحد.',
      leaveExactlyPins: maxPoints => `من فضلك اترك ${maxPoints} دبوس من كل نوع.`,
      leaveExactlyPinsAny: maxPoints => `الرجاء ترك ${maxPoints} دبابيس من أي نوع.`,
      leaveExactlyPinsPerPage: maxPoints => `من فضلك اترك ${maxPoints} دبوس .`,
      leaveComment: 'اكتب تحت الصورة لتترك تعليقًا.',
      noAnswers: 'لا يوجد خيار للإجابة، من فضلك انقر على التالي للمتابعة.',
      outOfPins: 'لقد فرغت من الدبابيس',
      pinsBehavior: 'أثناء تنقلك عبر الصورة، سترى مناطق ستُحدد بوضع دبوس واحد.',
      clusters: 'ستتمكن فقط من وضع الدبابيس في هذه المناطق المحددة.',
      contentAware: 'يمكنك وضع الدبابيس داخل المناطق المحددة أو خارجها.'
    },
    mp: {
      expand_note: 'يرجى تمرير مؤشر الماوس فوق الصورة (الصور) أو النقر عليها للتوسيع',
      rb_note: rows => `يرجى اختيار إجابة واحدة فقط لكل عنصر ${rows ? 'أدناه' : ''}`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return `يرجى تحديد ${min !== 1 ? 'أي' : 'فقط'} ${min} ${min !== 1 ? 'إجابات' : 'إجابة'} ${
            rows ? 'أدناه' : ''
          } لكل عنصر :`
        } else if (min > 0 && max < 5000) {
          return `يرجى اختيار ${min} ${min !== 1 ? 'إجابات' : 'إجابة'}  على الأقل، ولكن بما لا يزيد عن ${max} ${
            rows ? 'أدناه' : ''
          } لكل عنصر :`
        } else if (5000 === max && min > 0) {
          return `يرجى اختيار ${min} ${min !== 1 ? 'إجابات' : 'إجابة'} ${rows ? 'أدناه' : ''} على الأقل لكل عنصر :`
        } else if (0 === min && max < 5000) {
          return `يرجى اختيار ما لا يزيد عن ${max} ${max !== 1 ? 'إجابات' : 'إجابة'} ${rows ? 'أدناه' : ''} لكل عنصر :`
        } else {
          return 'تحقق من كل ما يُطبق:'
        }
      }
    },
    sh: {
      note: 'انقر فوق منتج لتكبيره وإضافته إلى عربة التسوق الافتراضية الخاصة بك إذا كنت ستشتريه من المتجر',
      amazonNote: 'انقر على المنتج لتكبير صورته وإضافته إلى سلة التسوق الافتراضية.',
      fullCart: 'عربة التسوق الخاصة بك ممتلئة!',
      qty: 'الكمية',
      each: 'كل',
      items: 'أغراض',
      addToCart: 'أضف إلى السلة',
      deleteFromCart: 'حذف',
      emptyCard: 'سلة التسوق فارغة',
      total: 'السلة',
      next: 'التالي',
      clearCart: 'تفريغ السلة',
      backToStore: 'العودة إلى المتجر',
      na: 'لاشيء مما سبق',
      scrollError: `يرجى التمرير بالكامل إلى اليسار واليمين للمتابعة في الاستبيان.`,
      maxCartCountError: max => `منتج إلى عربة التسوق${max}يُرجى عدم إضافة أكثر من `,
      maxSpentError: max => `  يُرجى عدم إنفاق أكثر من${max} `,
      maxProductCountError: max => `  يُرجى عدم إضافة كمية أكثر من${max}إلى عربة التسوق لكل منتج  `
    },
    rb: {
      note: 'من فضلك اختر عنصرًا واحدًا فقط:'
    },
    vo: {
      note: 'من فضلك شاهد الفيديو حتى نهايته\n'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'تحقق من كل مايُطبق:'
        } else if (min === max) {
          return `من فضلك اختر ${min !== 1 ? 'أي' : 'عنصر'} ${min} عناصر ${min !== 1 ? 'فقط' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `من فضلك اختر على الأقل ${min} عنصر ${min !== 1 ? 'عناصر' : ''} لكن ليس أكثر من ${max} لكل صف:`
        } else if (5000 === max && min > 0) {
          return `من فضلك اختر على الأقل ${min} عنصر ${min !== 1 ? 'عناصر' : ''}:`
        } else if (0 === min && max < 5000) {
          return `من فضلك اختر ما لا يزيد عن ${max} عنصر ${max !== 1 ? 'عناصر' : ''}:`
        } else {
          return 'تحقق من كل مايُطبق:'
        }
      }
    },
    oe: {
      na: 'غير قابل للتطبيق',
      note: (min, max, optional) => {
        if (min === max) {
          return `من فضلك اكتب ${1 !== min ? 'أي' : 'بالضبط'} ${min} رمز ${1 !== min ? 'رموز' : ''}${
            optional ? ' (اختياري)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `من فضلك اكتب على الأقل ${min} رمز ${1 !== min ? 'رموز' : ''} لكن ليس أكثر من ${max}${
            optional ? ' (اختياري)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `من فضلك اكتب على الأقل ${min} رمز ${1 !== min ? 'رموز' : ''}${optional ? ' (اختياري)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `من فضلك اكتب ما لا يزيد عن ${max} رمز ${1 !== min ? 'رموز' : ''}${optional ? ' (اختياري)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'من فضلك املأ الحقول التالية'
    },
    mx: {
      note: 'من فضلك حرك أشرطة التمرير المميزة للمتابعة',
      dragSlider: 'اسحب إلى اليسار أو اليمين للإجابة'
    },
    psc: {
      dragLeftRight: 'اسحب إلى اليسار أو اليمين للإجابة'
    },
    ps: {
      note: (value, remaining) => `من فضلك وزع بقية ${remaining ? 'المتبقية' : ''} ${value} بين العناصر أدناه`,
      allDone: `أُنجز كل شيئ!`,
      total: `مجموع:`,
      dragSlider: 'اسحب إلى اليسار أو اليمين للإجابة'
    },
    cx: {
      note: 'افتح القائمة المنسدلة وابدأ بكتابة جوابك عن طريق الممرر التلقائي أو حدده يدويًا'
    },
    ro: {
      note: 'اسحب للأعلى أو الأسفل من أجل إعادة الترتيب:'
    },
    md: {
      note1: 'من فضلك انقر/اضغط فوق عنصر خيارك الأول<br/>انقر/اضغط مرة ثانية لإزالة الاختيار.',
      note2: 'من فضلك انقر/اضغط فوق عنصر خيارك الأخير<br/>انقر/اضغط مرة ثانية لإزالة الاختيار.',
      note3: 'شكرًا! أكمل إلى السؤال التالي أو انقر/ اضغط على أي عنصر غير مختار للبدء من جديد.'
    },
    aro: {
      note: 'من فضلك اختر عنصرًا واحدًا من كل زوج.'
    },
    wd: {
      note: 'تأكد من أن كل قيمة لاحقة أكبر من القيمة السابقة.'
    },
    emd: {
      note: 'من فضلك شاهد الفيديو حتى نهايته\n',
      noAnswers: 'لايوجد خيار للجواب، من فضلك اضغط التالي للمتابعة',
      start: 'انقر مع الاستمرار للبدء',
      resume: 'انقر مع الاستمرار للاستئناف',
      continue: 'أنت جاهز! اضغط على التالي للمتابعة.',
      continueMobile: 'أنت مستعد! انقر هنا للمتابعة',
      training: {
        session: 'دورة تدريبية',
        note: 'الرجاء إنهاء التدريب',
        moveLeft: 'من فضلك اسحب القرص على طول الطريق إلى اليسار',
        moveBottom: 'من فضلك اسحب القرص حتى النهاية',
        moveRight: 'الآن، من فضلك اسحب أيقونة الاتصال الهاتفي على طول الطريق إلى اليمين',
        moveTop: 'من فضلك اسحب القرص على طول الطريق إلى الأعلى',
        success: 'عمل رائع!'
      }
    },
    sft: {
      noAnswers: 'لايوجد خيار للجواب، من فضلك اضغط التالي للمتابعة',
      note: 'يُرجى الإجابة بأسرع ما يمكن بالإجابة التي تشعر أنها صحيحة بشكل بديهي',
      finish: 'لقد انتهيت! الرجاء النقر فوق "موافق" للمتابعة',
      training: {
        start:
          '<p>سيُظهر لك هذا السؤال كلمات مختلفة بسرعة وسيتطلب تركيزك. ' +
          'ستحتاج إلى الرد بسرعة للإجابة' +
          '</p> <p>جاهز للتطبيق؟</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `مقبض "{buttonLeft}"`
            : (mouse ? `انقر "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `اضغط على مفتاح "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `مقبض "{buttonRight}"`
            : (mouse ? `انقر "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `اضغط على مفتاح "{keyBtnRight}"` : ''),
        fail: () => 'بطيئ جدًا',
        success: () => 'عظيم!',
        finish: () =>
          '<p><strong> رائع!</strong></p><p>يُرجى التأكد من أنك لن تشتت انتباهك في الدقائق 2-3 القادمة</p><p>انقر فوق "التالي" للبدء عندما تكون جاهزًا</p>'
      },
      buttons: {
        start: 'البدء',
        yesno: {
          left: 'نعم',
          right: 'لا'
        },
        matches: {
          left: 'تطابق',
          right: 'لا يوجد تطابق'
        },
        fits: {
          left: 'مناسب',
          right: 'غير مناسب'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
